import { memo } from 'react';
import { MenuItem as RACMenuItem, MenuItemProps as RACMenuItemProps } from 'react-aria-components';

import { ComponentContextProps, merge, renderWithContext, useComponent } from '@/components';

export type MenuItemProps = RACMenuItemProps & Partial<ComponentContextProps>;

const IMenuItem = ({ variant, className, children, ...rest }: MenuItemProps) => {
  const context = useComponent({ variant });

  /* prettier-ignore */
  const styles = [
    'cursor-pointer',
    'data-[disabled]:cursor-not-allowed',
    'flex',
    'flex-row',
    'gap-2',
    'group/menu-item',
    'items-center',
    'outline-none',
    'p-2',
    'rounded-lg',

    /* FieldCell */
    'group-[*]/field-options:px-2',
    'group-[*]/field-options:py-1',

    /* Toolbar */
    'group-[*]/runs-toolbar:p-sm',
  ];

  /* prettier-ignore */
  const plainStyles = [
    'hover:bg-gray-50',
    'data-[selected]:bg-gray-50'
  ];

  /* prettier-ignore */
  const errorStyles = [
    'hover:bg-gray-50',
  ];

  return (
    <RACMenuItem
      className={merge(
        styles,
        context.variant === 'plain' && plainStyles,
        context.variant === 'error' && errorStyles,
        context.variant === 'default' && plainStyles,
        className
      )}
      {...rest}
    >
      {renderWithContext(children, context)}
    </RACMenuItem>
  );
};

export const MenuItem = memo(IMenuItem) as typeof IMenuItem;
